import { createFileRoute } from '@tanstack/react-router';
import PatientPayPage from '~/components/OrderKits/PatientPayPage/PatientPayPage';
import { kitRequestsQueryOptions } from '~/services/practitioner/kitRequestsQueryOptions';

export const Route = createFileRoute('/_authed/order-kits/patient-pay')({
  loader: async ({ context }) => {
    if (context.isAuthenticated) {
      await context.queryClient.ensureQueryData(kitRequestsQueryOptions(true));
    }
  },
  component: PatientPayPage,
});
